import { IndividualHallBanquetHall, IndividualHallBrideRoom } from "@src/types/weddingHall";
import HallDetailCard from "./HallDetailCard";
import "./waitingRoomAndBanquetHallSection.scss";

type Props = {
  brideRoom: IndividualHallBrideRoom;
  banquetHall: IndividualHallBanquetHall;
  meals: {
    type: "BUFFET" | "COURSE" | "ONE_TABLE" | "ONE_TABLE_WITH_SEMI_BUFFET";
    ceremonyType: "SAME_TIME" | "SEPARATION";
  }[];
  capacity: number;
};

export default function WaitingRoomAndBanquetHallSection({
  brideRoom,
  banquetHall,
  meals,
  capacity,
}: Props) {
  return (
    <section className="section-container">
      {brideRoom.use && (
        <HallDetailCard
          type="waitingRoom"
          imgs={brideRoom.images}
          title="신부대기실"
          howToEnter={brideRoom.entranceMethods}
          toilet={brideRoom.provideToilet}
        />
      )}
      {banquetHall.use && (
        <HallDetailCard
          type="banquetHall"
          imgs={banquetHall.images}
          title="연회장"
          meals={meals}
          useTime={banquetHall.availableMinutes}
          capacity={capacity}
        />
      )}
    </section>
  );
}
